define([
    "jquery",
    "underscore",
    "marionette",
    "forms/account/change_leverage_form",
    "behaviors/form_errors_behavior",
    "backbone.syphon"
], function ($, _, Marionette, ChangeLeverageForm, FormErrorsBehavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        ui: {
            'tbody': '#leverage tbody',
            'mt4AccountNo': '#mt4_account_no',
            'submitBtn': '#submit_btn',
            'currentLeverage': '#current_leverage'
        },

        events: {
            'click @ui.submitBtn': 'submit',
            'change @ui.mt4AccountNo': 'updateLeverageList'
        },

        initialize: function () {
            this.bindUIElements();
        },

        updateLeverageList: function () {
            var contentString = "<tr>", i = 1, td_length = 5;

            const accountToFind = Number(this.ui.mt4AccountNo.val());
            const accountWithLeverage = window.accounts_with_leverage.find(account => account.mt4AccountNo == accountToFind);
            const leverageOptions = accountWithLeverage.leverageOptions


            this.ui.tbody.html("");
            _.each(leverageOptions, function (item, index) {
                contentString += '<td>'
                    + '<div class="radio">'
                    + '<label><input type="radio" name="leverage" value="' + item + '" id="leverage' + index + '">' + item + ':1</label>'
                    + '</div>'
                    + '</td>';
                if (0 == i % td_length) {
                    contentString += "</tr><tr>";
                    i = 1;
                } else {
                    i++;
                }
            });
            contentString += "</tr>";
            this.ui.tbody.append(contentString);

            // Also update the "current leverage"
            this.ui.currentLeverage.html(accountWithLeverage.leverage + ':1');
        },

        submit: function (e) {
            e.preventDefault();

            this.triggerMethod('hide:errors');

            var formData = Backbone.Syphon.serialize(this.$('#form_submit')[0]);
            var form = new ChangeLeverageForm();
            form.set(formData);

            var errors = form.validate();

            const accountToFind = formData['mt4_account_no']
            const accountWithLeverage = window.accounts_with_leverage.find(account => account.mt4AccountNo == accountToFind)
            const leverageOptions = accountWithLeverage.leverageOptions

            if (!leverageOptions.includes(Number(formData['leverage']))) {
                errors = _.extend({}, errors, {leverage: 'Invalid leverage.'});
            }

            var that = this;
            if (_.size(errors) < 1) {
                that.$('#form_submit').submit();
            } else {
                this.triggerMethod('show:errors', errors);
            }
        }
    });
});